import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shadow rounded-md bg-white w-full p-4" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = { class: "ml-auto" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.formMeta.code), 1),
      _createVNode(_component_font_awesome_icon, {
        icon: ['far', 'clone'],
        class: "cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.formMeta.code)))
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'share-alt'],
          class: "cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openShareMenu()))
        }),
        _createVNode(_component_router_link, {
          to: '/' + _ctx.formMeta.code + '/editor'
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"]),
        (!_ctx.isExpanded)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: ['fas', 'chevron-down'],
              class: "cursor-pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleState()))
            }))
          : _createCommentVNode("", true),
        (_ctx.isExpanded)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: ['fas', 'chevron-up'],
              class: "cursor-pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleState()))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("a", {
            href: _ctx.baseUrl + _ctx.formMeta.code + '/responses',
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'external-link-alt'] })
          ], 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}